import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface PostsStateType {
    readonly id: string;
    readonly parentId: string;
    readonly url: string;
}

export interface CustomBlogListStateType {
    readonly isLoading: boolean;
    readonly parameters: HasPagingParameters;
    readonly posts: PostsStateType[];
    readonly pagination?: PaginationModel;
    readonly filterQuery?: string;
}

export type CustomBlogListState = Readonly<CustomBlogListStateType>;

export const initialBlogState: CustomBlogListState = {
    isLoading: true,
    parameters: {
        page: 1,
    },
    posts: [],
};

export const customBlogListReducer = createTypedReducer(initialBlogState, {
    "Custom/BlogListState/Loading": (draft: Draft<CustomBlogListState>, { isLoading }: { isLoading: boolean }) => ({
        ...draft,
        isLoading,
    }),
    "Custom/BlogListState/Filter": (
        draft: Draft<CustomBlogListState>,
        { parameters }: { parameters: HasPagingParameters },
    ) => ({
        ...draft,
        parameters,
    }),
    "Custom/BlogListState/Posts": (draft: Draft<CustomBlogListState>, { posts }: { posts: PostsStateType[] }) => ({
        ...draft,
        posts,
    }),
    "Custom/BlogListState/Pagination": (
        draft: Draft<CustomBlogListState>,
        { pagination }: { pagination: PaginationModel },
    ) => ({
        ...draft,
        pagination,
    }),
    "Custom/BlogListState/SetFilterQuery": (
        draft: Draft<CustomBlogListState>,
        { result: filterQuery }: { result: string },
    ) => ({
        ...draft,
        filterQuery,
    }),
});
